import Button from './Button';
import ButtonGroup from '../../wui-button-group/src';
Button.Group = ButtonGroup;
export default Button;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-button/src/index.js